import useGoBack from 'utilities/navigation/back'
import React from 'react'
import CloseIcon from 'assets/images/rectangle/right-green.svg'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const goBack = useGoBack()
    return (
        <>
            <div className=" bg-transparent w-full px-4 h-14 flex items-center justify-between sticky top-0 z-20">
                <button
                    type="button"
                    onClick={goBack}
                    aria-label="بازگشت"
                    className=" -m-2.5 p-2.5 active:scale-90"
                >
                    <img src={CloseIcon} alt="" className=" w-6 h-6" />
                </button>
                <p className=" text-green-1 text-lg font-bold">{title}</p>
                <span className="w-6" />
            </div>
        </>
    )
}
